import { create } from "zustand";

export interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed"; platform: string }>;
}

interface PwaState {
  installPrompt: BeforeInstallPromptEvent | null;
  setInstallPrompt: (event: BeforeInstallPromptEvent | null) => void;
}

export const usePwaStore = create<PwaState>((set) => ({
  installPrompt: null,
  setInstallPrompt: (installPrompt) => set({ installPrompt })
}));
